import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {HttpClientModule} from '@angular/common/http';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatNativeDateModule} from '@angular/material/core';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatMenuModule} from "@angular/material/menu";
import {QueryFilterComponent} from "./query-filter/query-filter.component";
import {QueryFilterDialogComponent} from "./query-filter-dialog/query-filter-dialog.component";
import {RatingsFilterDialogComponent} from "./ratings-filter-dialog/ratings-filter-dialog.component";
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FilterParamDialogComponent } from './filter-param-dialog/filter-param-dialog.component';
import { FilterCountryDialogComponent } from './filter-country-dialog/filter-country-dialog.component';
import { FilterSimilarDialogComponent } from './filter-similar-dialog/filter-similar-dialog.component';
import { FilterUniversityDialogComponent } from './filter-university-dialog/filter-university-dialog.component';
import { MatTooltipModule} from "@angular/material/tooltip";
import {MatTableModule} from "@angular/material/table";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {IndicatorSelectComponent} from "./indicator-select/indicator-select.component";
import { CheckFiltersDialogComponent } from './check-filters-dialog/check-filters-dialog.component';
import {RatingSelectDialogComponent} from "./rating-select-dialog/rating-select-dialog.component";
import {ConfirmDialogComponent} from "./confirm-dialog/confirm-dialog.component";


@NgModule({
  declarations: [
    QueryFilterComponent,
    QueryFilterDialogComponent,
    RatingsFilterDialogComponent,
    FilterParamDialogComponent,
    FilterCountryDialogComponent,
    FilterSimilarDialogComponent,
    FilterUniversityDialogComponent,
    IndicatorSelectComponent,
    CheckFiltersDialogComponent,
    RatingSelectDialogComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    NgxSliderModule,
    MatDialogModule,
    MatTableModule,
    MatProgressSpinnerModule,
    ScrollingModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatCardModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTableModule,
    MatDialogModule,
    MatMenuModule,
    QueryFilterComponent,
    QueryFilterDialogComponent,
    RatingsFilterDialogComponent,
    NgxSliderModule,
    IndicatorSelectComponent,
    RatingSelectDialogComponent,
    ConfirmDialogComponent,
  ],
  entryComponents: [
    QueryFilterComponent,
    QueryFilterDialogComponent,
    RatingsFilterDialogComponent,
    IndicatorSelectComponent,
    RatingSelectDialogComponent,
  ]
})

export class SharedModule {
}
